module.exports = __webpack_public_path__ + "static/media/Sharpedo_gaussian2.19fb8806.png";